export default {"src":"/_next/static/media/IconCheckWhite.b45e2d5f.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};